module.exports = __webpack_public_path__ + "img/hospital1.e4742728.png";